import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "appointmentContent" }
const _hoisted_2 = { class: "w100 centered mt20" }
const _hoisted_3 = { class: "fr pointer" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "fs20 fw600"
}
const _hoisted_7 = {
  key: 1,
  class: "fs20 fw600"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb10" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = { class: "w100 centered mt20 llgreyBg rad8 pad20 posRe" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs15 fw600 dgrey" }, "選択中のサブ調整カレンダー", -1)
const _hoisted_17 = {
  class: "centered posRe w100 rad10 circle_button blueAround mb10 mt10",
  style: { padding: `0px` }
}
const _hoisted_18 = {
  class: /*#__PURE__*/_normalizeClass(`fl fs14 centered mt7 fw600 pad5`),
  style: {}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20 llgreyBg rad8 pad20" }, "サブ調整カレンダーは設定されていません", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt40" }, "割当設定", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "担当者を割り当てるルールを設定できます。", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", null, "割り当て比率の設定", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "割り当て比率 (0~100) ※0だと提案されません。", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = { class: "fl mr20" }
const _hoisted_34 = {
  class: "kireiOrangeBg fl centered rad10 whiteColor pad5 fs16 mt5 mr10",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "w100 rad8 llgreyBg pad20 mt20 centered"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "w100 centered mt10 skyblueBg pad10 rad8" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { class: "w100 centered mt10 skyblueBg pad10 rad8" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_47 = {
  key: 2,
  class: "w100 centered mt20 llgreyBg rad8 pad20",
  style: {}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "fs15 fw600 dgrey" }, "日程を確定しないお相手の提案下限件数", -1)
const _hoisted_49 = {
  class: "mt10 mc",
  style: {"width":"60px"}
}
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "fr mt20"
}
const _hoisted_54 = {
  class: "fw600 fl fs14",
  style: {"margin-top":"5px"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 fw600 pad5`),
  style: {"margin-top":"30px"}
}, "新規調整カレンダーを作成", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = {
  key: 3,
  class: "w100 ofs"
}
const _hoisted_61 = {
  key: 0,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"0px","right":"0px","background":"#69d54f"}
}
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 centered mt20" }, "もっと見る", -1)
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_AstagSearchBox = _resolveComponent("AstagSearchBox")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/reload.png`),
            width: "30",
            height: "30",
            class: "mt4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshPreviewSchedule && _ctx.refreshPreviewSchedule(...args)))
          }, null, 8, _hoisted_4), [
            [_directive_tooltip, `表示を更新`]
          ])
        ]),
        _hoisted_5,
        (_ctx.panelType == `subAstag`)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "サブ調整カレンダー"))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "調整カレンダー一覧"))
      ]),
      _hoisted_8,
      _hoisted_9,
      (_ctx.panelType == `subAstag`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'list' ? 'selected fw600' : ''
                    }`),
              style: {"width":"50%"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('list')))
            }, " 一覧 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                        _ctx.selectedTabName == 'setting' ? 'selected fw600' : ''
                    }`),
              style: {
                        width: `50%`,
                    },
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategoryTab('setting')))
            }, " 設定 ", 2),
            _hoisted_11,
            (_ctx.selectedTabName == 'list')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.rcm.subAstag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("label", _hoisted_17, [
                            _createVNode(_component_CalendarIcon, {
                              astag: _ctx.rcm.subAstag,
                              width: 40,
                              iconWidth: 40,
                              totalHeight: 40,
                              canDelete: false,
                              hideName: true,
                              hideBorder: true,
                              classes: `fl mt3 ml10`,
                              showSharedInfo: false
                            }, null, 8, ["astag"]),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.truncate(_ctx.rcm.subAstag.name, 18)), 1)
                          ]),
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                            width: "20",
                            height: "20",
                            class: "pointer rad10 posAb",
                            style: {"right":"18px","top":"40px","box-shadow":"2px 2px 2px rgba(0, 0, 0, 0.3)"},
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deselectSubAstag && _ctx.deselectSubAstag(...args)))
                          }, null, 8, _hoisted_19),
                          _hoisted_20
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
                ]))
              : (_ctx.selectedTabName == 'setting')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", null, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("div", null, [
                        ([`equal`, `priority`].includes(_ctx.magRuleOption))
                          ? (_openBlock(), _createBlock(_component_SelectTag, {
                              key: 0,
                              class: "fl fs14 roundForm",
                              style: {"min-width":"30px","height":"50px"},
                              options: _ctx.SelectUtil.periodDaysForAssignOptions.map(mt => mt.name),
                              optionName: `period_days_for_assign`,
                              defaultOption: _ctx.getDefaultPeriodDaysForAssignName(),
                              onSelectValue: _ctx.selectPeriodDaysForAssign
                            }, null, 8, ["options", "defaultOption", "onSelectValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_SelectTag, {
                          class: "fl fs14 roundForm",
                          style: {"min-width":"330px","height":"50px"},
                          options: _ctx.SelectUtil.assignMagRuleOptions.map(mt => mt.name),
                          optionName: `assign_sub_astag_mag_rule`,
                          defaultOption: _ctx.getDefaultAssignMagRuleName(),
                          onSelectValue: _ctx.selectAssignMagRule
                        }, null, 8, ["options", "defaultOption", "onSelectValue"])
                      ]),
                      _hoisted_28
                    ]),
                    _createElementVNode("div", null, [
                      (
                                _ctx.rcm &&
                                _ctx.rcm.room_setting &&
                                [`priority`, `priority_by_this_month`].includes(_ctx.rcm.room_setting.assign_sub_astag_mag_rule) &&
                                _ctx.rcm.subAstag &&
                                _ctx.rcm.subAstag.meeting_attendees_groups?.length > 1
                            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _hoisted_30,
                            _hoisted_31,
                            (_ctx.displaySaveButton)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3 mt2",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveSubAstag && _ctx.saveSubAstag(...args)))
                                }, " サブ調整カレンダーの変更を保存 "))
                              : _createCommentVNode("", true),
                            _hoisted_32,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.subAstag.meeting_attendees_groups, (mag) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "fl",
                                key: mag.id
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(mag.name), 1),
                                  _createVNode(_component_MdTextfieldTag, {
                                    style: {"height":"56px","min-width":"80px"},
                                    fieldStyle: "min-width:80px;",
                                    class: "fl fs14 mb5",
                                    type: `number`,
                                    min: 0,
                                    max: 100,
                                    value: mag.priority,
                                    retValue: mag.id,
                                    onInputValue: _ctx.inputPriority
                                  }, null, 8, ["value", "retValue", "onInputValue"]),
                                  _hoisted_35
                                ])
                              ]))
                            }), 128)),
                            _hoisted_36
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_37
                  ]))
                : _createCommentVNode("", true),
            _hoisted_38
          ]))
        : _createCommentVNode("", true),
      ((_ctx.rcm.members || []).length >= 2 && !_ctx.rcm.appo.required_owner_participation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            (_ctx.rm.chukaiAstag.id != `newId`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createTextVNode(" オーナーが参加しないため、不参加カレンダーを利用しています。"),
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_router_link, {
                      to: "/settings/not_attendees_calendar",
                      class: "whiteColor fw600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("不参加カレンダーを編集")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createTextVNode(" オーナーが参加しないため、不参加カレンダーを利用します。"),
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_router_link, {
                      to: "/settings/not_attendees_calendar",
                      class: "whiteColor fw600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("不参加カレンダーを作成")
                      ]),
                      _: 1
                    })
                  ])
                ])),
            _hoisted_46,
            (_ctx.rm.user_setting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_MdTextfieldTag, {
                      name: "",
                      style: {"height":"56px","min-width":"60px"},
                      fieldStyle: `min-width:60px;font-size:20px;`,
                      class: "fs20",
                      value: 
                                _ctx.rcm.room_setting && _ctx.rcm.room_setting.submit_lower_limit_num
                                    ? _ctx.rcm.room_setting.submit_lower_limit_num
                                    : _ctx.rm.user_setting && _ctx.rm.user_setting.submit_lower_limit_num
                                    ? _ctx.rm.user_setting.submit_lower_limit_num
                                    : 0
                            ,
                      type: "number",
                      min: 0,
                      onInputValue: _ctx.inputSubmitNum,
                      required: ""
                    }, null, 8, ["value", "onInputValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
            ([`astag`, `subAstag`].includes(_ctx.panelType) && _ctx.selectedTabName == 'list')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _hoisted_52,
                  (_ctx.rcm.astag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("span", _hoisted_54, [
                          _createTextVNode("不参加カレンダーを適用    "),
                          _createVNode(_component_IconHelp, {
                            width: 18,
                            tooltipText: `オーナーの予定を考慮しないカレンダーを適用します。`,
                            style: {"margin-top":"-3px","margin-right":"5px"}
                          })
                        ]),
                        _createVNode(_component_Switcher, {
                          value: "type[not_attend]",
                          name: "不参加カレンダーを適用",
                          checked: _ctx.panelType == `subAstag` ? _ctx.rcm.subAstag?.type == 10 : _ctx.rcm.astag?.type == 10,
                          display: "true",
                          class: "checkUsingCal fl",
                          onSelect: _ctx.useNotAttendCalendar
                        }, null, 8, ["checked", "onSelect"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_55,
                  (_ctx.rm.astagsTab?.tab_name != `default`)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "fs12 mt2 fl pointer mt20 pad5",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCategoryTab(`default`)))
                      }, [
                        _createTextVNode(" 一覧に"),
                        _hoisted_56,
                        _createTextVNode("戻る ")
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_AstagSearchBox, {
                    class: "fr mt20",
                    style: {"height":"40px"},
                    canSelectShared: false
                  }),
                  (_ctx.panelType == `astag`)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 2,
                        class: "centered posRe w100 rad10 circle_button blueAround mb10",
                        style: {
                            marginTop: `30px`,
                        },
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createNewAstag && _ctx.createNewAstag(...args)))
                      }, _hoisted_58))
                    : _createCommentVNode("", true),
                  _hoisted_59,
                  (_ctx.astags)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.astags, (_astag, astagindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${astagindex}${_astag.selected}${_astag.id}${_astag.type}${_astag.name}${_ctx.systemUpdatedAt}`,
                            class: "mb10 fl posRe centered mr10"
                          }, [
                            _createVNode(_component_CalendarIcon, {
                              astag: _astag,
                              width: 140,
                              iconWidth: 50,
                              totalHeight: 140,
                              onClickAstag: _ctx.selectAstag,
                              canDelete: false,
                              canEdit: _ctx.panelType == `subAstag` ? false : true,
                              onClickEdit: _ctx.clickEditAstag,
                              iconStyles: {
                                    marginLeft: `18%`,
                                    paddingTop: `20px`,
                                }
                            }, null, 8, ["astag", "onClickAstag", "canEdit", "onClickEdit"]),
                            (
                                    (_ctx.panelType == `astag` && _ctx.rcm.astag && _ctx.rcm.astag.id == _astag.id) ||
                                    (_ctx.panelType == `subAstag` && _ctx.rcm.subAstag && _ctx.rcm.subAstag.id == _astag.id)
                                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                                    width: "17",
                                    height: "17",
                                    style: {"margin-top":"-2px"}
                                  }, null, 8, _hoisted_62)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _hoisted_63,
                        (_ctx.astagsTab.tab_name == `default` && _ctx.astagsTab?.has_next)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: {"width":"120px","height":"120px"},
                              class: "mb10 fl posRe centered mr10 mt20 pointer hoverLgreyBg rad10",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getNextPage && _ctx.getNextPage(...args)))
                            }, [
                              _createElementVNode("div", null, [
                                _hoisted_64,
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/roundarrowS.png`),
                                  width: "25",
                                  height: "25",
                                  class: "mt10 mr7"
                                }, null, 8, _hoisted_65),
                                _hoisted_66
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_67
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_68
                ]))
              : _createCommentVNode("", true)
          ])),
      _hoisted_69
    ])
  ]))
}